import { SparqlEditor } from './src/SparqlEditor.js'

window.customElements.define('sparql-editor', SparqlEditor)
